export const PAGE_ROUTE_NAMES = {
  REGION: 'regions-rid',
  REGION_SEARCH: 'regions-rid-search',
  REGION_CATEGORIES: 'regions-rid-categories-id',
  REGION_THEMES: 'regions-rid-themes-id',
  REGION_TAG: 'regions-rid-tags-id',
}
